export function usePostMenu() {
 const menu = ref(null);
 function closeMenu() { if (menu.value) menu.value.open = false; }
 function onMenuFocusout(event) {
  // Safari can report null when pressing a menu link. Hiding it on blur
  // cancels the following click; an outside pointer click closes it instead.
  if (event.relatedTarget && !menu.value?.contains(event.relatedTarget)) closeMenu();
 }
 onClickOutside(menu, closeMenu);
 return { menu, closeMenu, onMenuFocusout };
}
